
import { ChevronLeft, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { cn } from "../../lib/utils";
import { useIsMobile } from "../../hooks/use-mobile";
import { useNavigate } from "react-router-dom";
import React from "react";

interface HeaderControlsProps {
  onDelete: () => void;
  className?: string;
}

export function HeaderControls({ onDelete, className }: HeaderControlsProps) {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleBack = () => {
    // If there's history, go back
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      // Fallback to a safe default route if there's no history
      navigate("/app/dashboard");
    }
  };

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Button
        variant="outline"
        onClick={handleBack}
        className="flex items-center rounded-full gap-2"
      >
        <ChevronLeft className="h-6 w-6" />
        {!isMobile && <span className="font-medium">Back</span>}
      </Button>
      <Button
        variant="destructive"
        onClick={onDelete}
        className="h-10 w-10 rounded-full p-0"
      >
        <Trash2 className="h-6 w-6" />
      </Button>
    </div>
  );
}
